import React from "react";
import { arrayOf, shape, string } from "prop-types";
import { connect } from "react-redux";
import Resources from "../../components/Resources";

import { findUmbraccoResources } from "./util";

const ResourcesMindEBooklets = ({ resources }) => {
  const requiredResources = findUmbraccoResources(
    resources,
    "Mental health at work (Mind e-booklet)",
    "Supporting someone else (Mind e-booklet)",
    "How to deal with anger (Mind e-booklet)",
    "How to manage stress (Mind e-booklet)",
    "Making sense of peer support (Mind e-booklet)",
    "Seeking help for a mental health problem (Mind e-booklet)",
    "Understanding anxiety (Mind e-booklet)",
    "Understanding depression (Mind e-booklet)",
    "Eating problems (Mind e-booklet)",
    "Understand mental health problems (Mind e-booklet)",
    "Understanding postnatal and perinatal mental health (Mind e-booklet)",
    "Understanding self-harm (Mind e-booklet)"
  );

  const res = [...(requiredResources || [])];

  return <Resources resources={res} title="Mind e-booklets" />;
};

ResourcesMindEBooklets.propTypes = {
  resources: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
      link: string,
      cta: string,
    })
  ),
};

const mapStateToProps = (state) => ({
  resources: state.core.umbracoContent.resources,
});

const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ResourcesMindEBooklets);
